import { DSNCPoll, DSPoll, DSPollChoice } from 'shared-definitions/types'
import { ApiChoiceProps, ApiComponentPollsProps, ApiPollProps } from 'data-source/types.wp'
import { optionalLinkMapper } from 'data-source/mappers/optionalLinkMapper'

export function ncPoll(input: ApiComponentPollsProps): DSNCPoll {
  return {
    resource: 'nc-poll',
    postId: input.post_id.toString(),
    items: input.polls.map(pollMapper),
  }
}

function pollMapper(input: ApiPollProps): DSPoll {
  const votes = input.choices.reduce((carry, item) => carry + item.value, 0)

  return {
    votes,
    id: input.poll_id.toString(),
    question: input.question,
    items: input.choices.map(choiceMapper),
    pLinkEdit: optionalLinkMapper(input.edit_url),
  }
}

function choiceMapper(input: ApiChoiceProps): DSPollChoice {
  return {
    id: input.choice_id,
    answer: input.choice,
    value: input.value,
  }
}
